import { useCallback, useEffect } from 'react';

export const useScrollToTop = () => {
  const scrollTop = useCallback(() => window.scrollTo({ behavior: 'smooth', top: 0 }), []);
  useEffect(() => {
    // doing it in the next tick to ensure that the scroll is done after the render
    const timeout = setTimeout(() => {
      scrollTop();
    }, 0);

    return () => {
      clearTimeout(timeout);
    };
  }, [scrollTop]);

  return {
    scrollTop
  };
};
